import { Chip, Stack, Typography, alpha } from "@mui/material";
import React, { FC } from "react";

export const PostMeta: FC<PostMetaProps> = ({
  readingTime,
  publishedAt,
  latest = false
}) => (
    <Stack
      direction="row"
      spacing={0.5}
      alignItems="center"
      sx={{
        fontSize: "0.75rem",
        lineHeight: 1
      }}
    >
      {latest && (
        <Chip
          size="small"
          label="Latest"
          sx={{
            borderRadius: 1.75,
            fontSize: "inherit",
            lineHeight: "inherit",

            bgcolor: ({ palette }) => palette.accent.main
          }}
        />
      )}
      {!!readingTime && (
        <Chip
          size="small"
          label={`${readingTime} ${readingTime === 1 ? "minute" : "minutes"}`}
          sx={{
            borderRadius: 1.75,
            fontSize: "inherit",
            lineHeight: "inherit",
            color: ({ palette }) => palette.primary.dark,
            bgcolor: ({ palette }) => alpha(palette.primary.main, 0.08)
          }}
        />
      )}
      {publishedAt && (
        <Typography
          component="span"
          fontSize="inherit"
          lineHeight="inherit"
          color="textSecondary"
        >
          {publishedAt}
        </Typography>
      )}
    </Stack>
  );

export interface PostMetaProps {
  latest?: boolean;
  readingTime: number | null;
  publishedAt: string | null;
}
